module.exports = __webpack_public_path__ + "static/media/ruleImg3.d796bc2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ruleImg3.png
// module id = 1854
// module chunks = 0 1